import React from 'react';
import styles from './index.module.scss';

type Props = {
  label?: string;
  children: React.ReactNode;
};

export const PointsList = ({ label = 'ポイント', children }: Props) => (
  <div className={styles.base}>
    <div className={styles.label}>{label}</div>
    <ol className={styles['numbered-list-container']}>
      {React.Children.toArray(children).flatMap((child, index) => {
        if (React.isValidElement(child)) {
          return [child];
        }

        if (typeof child === 'string') {
          const text = child.trim();
          if (!text) {
            return [];
          }
          return [<li key={`text-${index}`}>{text}</li>];
        }

        return [<li key={`node-${index}`}>{child}</li>];
      })}
    </ol>
  </div>
);
